import Application from "../../Application";
import PaymentInstructionPresenter, {
  IPaymentInstructionPresenter
} from "../../presenter/payment/PaymentInstructionPresenter";
import { IPaymentService } from "../../service/payment/PaymentService";
import { INotificationService } from "../../service/notification/NotificationService";
import { TPaymentInstructionPresentationModel } from "../../presenter/payment/model/PaymentInstructionPresentationModel";
import { UserPreferences } from "../../common/Constants";
import { ICredentialService } from "../../service/credential/CredentialService";

export default class ShowPaymentConfirmationInteractor {
  private application: Application;
  private output?: IPaymentInstructionPresenter;
  private paymentService: IPaymentService;
  private notificationService: INotificationService;
  private credentialService: ICredentialService;

  constructor({
    application,
    paymentService,
    notificationService,
    credentialService
  }: {
    application: Application;
    paymentService: IPaymentService;
    notificationService: INotificationService;
    credentialService: ICredentialService;
  }) {
    this.application = application;
    this.paymentService = paymentService;
    this.notificationService = notificationService;
    this.credentialService = credentialService;
  }

  async validateToken(token: string) {
    return this.paymentService.validateToken(token);
  }

  async decodeInstructionToken(token: string) {
    return this.paymentService.decodeInstructionToken(token);
  }

  execute(token: string) {
    this.output = PaymentInstructionPresenter({
      application: this.application,
      initialState: {
        paymentInstruction: {} as TPaymentInstructionPresentationModel,
        languageCode: UserPreferences.DEFAULT_LANGUAGE
      }
    });

    this.credentialService.getLanguage().then((languageCode) => {
      this.application.container.registerValue(
        "language",
        languageCode || UserPreferences.DEFAULT_LANGUAGE
      );
      this.output?.setLanguageCode(
        languageCode || UserPreferences.DEFAULT_LANGUAGE
      );
    });

    this.validateToken(token)
      .then((response) =>
        this.decodeInstructionToken(token).then((instruction) =>
          this.output?.setInstruction(instruction)
        )
      )
      .catch((e) => {
        this.notificationService.showError(e.message);
        this.output?.loader.stop("paymentInstructionLoader");
        throw e;
      });

    return this.output;
  }
}
